export enum Applications {
	SEABISCUIT_NA = 'seabiscuit-na',
	SFRA_APAC_KR = 'sfra-apac-kr',
	SFRA_APAC_SEA_TH = 'sfra-apac-sea-th',
	SFRA_EU = 'sfra-eu',
	SHOPAPP_ANDROID = 'shop-app-android',
	SHOPAPP_IOS = 'shop-app-ios',
	UA_NEXT = 'ua-next',
}

export enum Brands {
	ADMIN = 'ua-admin',
	APP_US = 'us-shop',
	NEXT_UK = 'uk-next',
	WEB_AU = 'au-web',
	WEB_CA = 'ca-web',
	WEB_CH = 'ch-web',
	WEB_DE = 'de-web',
	WEB_ES = 'es-web',
	WEB_EU = 'eu-web',
	WEB_FR = 'fr-web',
	WEB_HK = 'hk-web',
	WEB_IE = 'ie-web',
	WEB_IT = 'it-web',
	WEB_KR = 'kr-web',
	WEB_MX = 'mx-web',
	WEB_MY = 'my-web',
	WEB_NL = 'nl-web',
	WEB_NO = 'no-web',
	WEB_PL = 'pl-web',
	WEB_PT = 'pt-web',
	WEB_SG = 'sg-web',
	WEB_TH = 'th-web',
	WEB_UK = 'uk-web',
	WEB_US = 'us-web',
}

// import type { FlowIdentifier } from '@okta/okta-auth-js/types/lib/idx/types/FlowIdentifier'
export enum Flows {
	LOGIN = 'login',
	REGISTER = 'register',
	RESET_PASSWORD = 'resetPassword',
}

export enum Hints {
	UPDATE_PASSWORD = 'update-password',
}

/**
 * enroll-profile (sign-up)
 * identify (sign-in)
 * identify-recovery (forgot password step 1)
 * authenticator-verification-data (forgot password step 2)
 * challenge-authenticator (forgot password step 3)
 * reset-authenticator (forgot password step 4)
 * terminal (forgot password step 4a)
 */
export enum ContextViews {
	LOGIN = 'identify',
	REGISTER = 'enroll-profile',
	CHALLENGE_AUTHENTICATOR = 'challenge-authenticator',
	SELECT_AUTHENTICATOR = 'select-authenticator-enroll',
	RESET_PASSWORD_1 = 'identify-recovery',
	RESET_PASSWORD_2 = 'authenticator-verification-data',
	RESET_PASSWORD_4 = 'reset-authenticator',
	RESET_PASSWORD_4a = 'terminal',
	FAILURE_REDIRECT = 'failure-redirect',
	SUCCESS_REDIRECT = 'success-redirect',
}
